'use client';

import { useEffect, type RefObject } from 'react';

export function useVideoLazyLoad(
    videoRef: RefObject<HTMLVideoElement | null>,
    threshold = 0.3
) {
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    video.play().catch(() => {});
                } else {
                    video.pause();
                }
            },
            { threshold }
        );

        observer.observe(video);
        return () => observer.disconnect();
    }, [videoRef, threshold]);
}
